import type {ProductCatalogItem, StoreEconomicsNoticeSkuRef} from '@ozon-ai/ozon/contracts';
import type {PurchaseLineInput, PurchaseResponse} from '@ozon-ai/procurement/contracts';
import {api} from '../../../api/client';

function resolveCatalogItem(
	item: StoreEconomicsNoticeSkuRef,
	catalog: ProductCatalogItem[],
): ProductCatalogItem | undefined {
	if (item.offerId) {
		const byOffer = catalog.find((entry) => entry.offerId === item.offerId);
		if (byOffer) return byOffer;
	}
	return catalog.find((entry) => entry.ozonSku === item.sku);
}

function missingCogsToLines(
	items: StoreEconomicsNoticeSkuRef[],
	catalog: ProductCatalogItem[],
	skuLabels: Map<string, string>,
): PurchaseLineInput[] {
	const lines: PurchaseLineInput[] = [];
	for (const item of items) {
		const catalogItem = resolveCatalogItem(item, catalog);
		const offerId = item.offerId?.trim() || catalogItem?.offerId?.trim() || '';
		if (!offerId) continue;
		lines.push({
			id: crypto.randomUUID(),
			offerId,
			ozonSku: item.sku || catalogItem?.ozonSku,
			productName: catalogItem?.name ?? skuLabels.get(item.sku),
			quantity: 0,
			unitPriceRub: 0,
		});
	}
	return lines;
}

export async function createPurchaseForMissingCogs(params: {
	effectiveFrom: string;
	items: StoreEconomicsNoticeSkuRef[];
	catalog: ProductCatalogItem[];
	skuLabels: Map<string, string>;
}): Promise<string> {
	const created = await api.post<PurchaseResponse>('/purchases', {});
	const lines = missingCogsToLines(params.items, params.catalog, params.skuLabels);
	await api.put<PurchaseResponse>('/purchases', {
		id: created.id,
		deliveryRub: 0,
		effectiveFrom: params.effectiveFrom,
		lines,
	});
	return created.id;
}
